import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Translate } from 'react-localize-redux';
import { useParams } from 'react-router';

import Spacer from '@fd/ui/Spacer';

import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';
import { permissionsSelector } from '../../../selectors/permissions.selector';
import { PortalFeatureFlags } from '../../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../../services/featureFlags/useFeatureFlagValue';
import { ClientReportingMicroFrontend } from '../../Finance/ClientReportingPayoutsMFE';

const canViewSalesStatistics = permissionsSelector.hasPermissionFactory(['ViewSalesStatistics']);
const canViewEndOfDayStatistics = permissionsSelector.hasPermissionFactory([
  'ViewSalesEndOfDayStatistics',
]);

export const HomeLiveReportWidget = (): JSX.Element | null => {
  const { appId: routeAppId } = useParams<{ appId?: string }>();
  const currentApp = useAppSelector((state) => state.currentApp);
  const hasSalesStatisticsPermission = useAppSelector(canViewSalesStatistics);
  const hasEndOfDayStatisticsPermission = useAppSelector(canViewEndOfDayStatistics);
  const isEnabled = useFeatureFlagValue(PortalFeatureFlags.liveOverviewReportHomepage, false);

  const appId = currentApp?.AppId?.trim() ?? '';
  const orgId = currentApp?.OrgId?.trim() ?? '';
  const canMount =
    isEnabled &&
    appId !== '' &&
    orgId !== '' &&
    routeAppId === appId &&
    appId !== 'flipdish-global' &&
    hasSalesStatisticsPermission &&
    hasEndOfDayStatisticsPermission;

  if (!canMount) {
    return null;
  }

  return (
    <Grid item xs={12} data-fd="home-live-report-widget">
      <Typography variant="h6" component="h2">
        <Translate id="Live_report" />
      </Typography>
      <Spacer size={16} />
      <ErrorBoundary
        key={`${orgId}:${appId}`}
        identifier="home-live-report-widget"
        includeTowlie={false}
      >
        <ClientReportingMicroFrontend
          portalSection="home"
          dataFd="home-live-report-micro-frontend"
          mfeRoute="live-report"
        />
      </ErrorBoundary>
      <Spacer size={24} />
    </Grid>
  );
};

export default HomeLiveReportWidget;
